import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated } = useAuth()
  
  // 同时检查 localStorage，确保登录状态同步
  const hasTokenInStorage = typeof window !== 'undefined' && localStorage.getItem('token')

  if (!isAuthenticated && !hasTokenInStorage) {
    // 未登录，重定向到登录页
    return <Navigate to="/login" replace />
  }

  // 已登录，显示子组件
  return children
}
